<template>
    <div>
        <div v-if="region.name === 'Centro-Oeste'">
            <p>
                O <strong>Centro-Oeste brasileiro</strong> é onde está localizada a capital do país
                e a <strong>capital nacional do rock</strong>: Brasília. Também é lá que vivem os
                <strong>Presidentes da República</strong> durante o mandato, no
                <strong>Palácio da Alvorada</strong>. Essa região conta com belezas naturais
                deslumbrantes. Tem o <strong>Parque Indígena do Xingu</strong>, que é a maior terra
                indígena do mundo, e um dos <strong>Patrimônios Naturais Mundiais</strong> pela
                UNESCO: o <strong>Complexo do Pantanal</strong>. Ele é uma das mais extensas
                planícies inundáveis do planeta, com altíssima biodiversidade, e compõe um lindo
                mosaico de vários biomas em um só.
            </p>
        </div>
        <div v-if="region.name === 'Nordeste'">
            <p>
                Tá achando que o <strong>Nordeste</strong> do Brasil se resume a belas praias?! Se
                você olhar mais de perto, vai ver que essa região é cheia de história desde muito
                antes da chegada dos colonizadores portugueses - que se aprochegaram por lá! Seus
                nove estados estão divididos entre quatro sub-regiões muito diferentes entre si. O
                Nordeste também é cheio de exclusividades: o bioma da <strong>Caatinga</strong> só é
                encontrado por lá, o
                <strong>carnaval</strong>
                da região é o melhor e mais tradicional do país e é lá que fica a cidade que é
                considerada a mais negra fora do continente africano: <strong>Salvador</strong>!
            </p>
        </div>
        <div v-if="region.name === 'Norte'">
            <p>
                Uma região <strong>maceta</strong> dessas, que ocupa quase metade de todo o
                território nacional, dominada pela <strong>biodiversidade</strong> e pela
                diversidade cultural, com certeza tem muita história a contar! O
                <strong>Norte do Brasil</strong> é cheio de vida e inundado por
                <strong>belezas naturais</strong> de todos os tipos. Afinal, é lá que estão
                localizados a <strong>maior floresta tropical do planeta</strong>, o ponto mais alto
                do Brasil e a <strong>maior bacia hidrográfica do mundo</strong>. Além de tudo isso,
                a cultura dessa região é muito marcante e conhecida pelo país inteiro: já ouviu as
                lendas do <strong>boto-cor-de-rosa</strong> e do <strong>Bumba Meu Boi</strong>? São
                de lá!
            </p>
        </div>
        <div v-if="region.name === 'Sudeste'">
            <p>
                Terra da <strong>Chico Rei</strong>, dos <strong>mares de morros</strong> e dos mais
                diferentes sotaques em um só canto, o <strong>Sudeste</strong> é a região com o
                maior número de pessoas no país. Composto pelos estados de
                <strong>Minas Gerais</strong>, <strong>Rio de Janeiro</strong>,
                <strong>São Paulo</strong> e <strong>Espírito Santo</strong>, foi por aqui que foram
                descobertos e mais explorados o <strong>ouro</strong> e as
                <strong>pedras preciosas</strong>. E também foi onde se expandiram as
                <strong>lavouras de café</strong>. Além disso, a região carrega a bandeira de ter
                sido o lugar onde se declarou a <strong>independência do Brasil</strong>, e é onde
                está localizada uma das 7 maravilhas do mundo: o <strong>Cristo Redentor</strong>.
            </p>
        </div>
        <div v-if="region.name === 'Sul'">
            <p>
                <strong>Bah</strong>, tu tens que conhecer o <strong>Sul</strong> do Brasil! O
                povoamento de lá se deu pelos jesuítas espanhóis e, desde então, recebeu forte
                influência de várias outras culturas, como a dos <strong>indígenas</strong>, a dos
                <strong>alemães</strong>, a dos <strong>portugueses</strong> e a dos
                <strong>japoneses</strong>. Com as estações do ano bem definidas, o Sul tem invernos
                congelantes e verões ensolarados. Esse clima variado combina bem com os pontos
                turísticos da região: praias, <strong>pampas</strong>, montanhas, cataratas... Lá é
                <strong>tri bonito</strong>. Ah, e tudo isso sempre acompanhado de um bom
                <strong>chimarrão</strong> ou uma <strong>taça de vinho</strong>, é claro!
            </p>
        </div>

        <div v-if="region.products.data.length">
            <div class="d-flex flex-align-center mt-4 mb-3">
                <h3 class="my-0 flex-child-fixed">Produtos</h3>
                <router-link
                    :to="{ name: `${regionName}-products` }"
                    class="flex-child-fixed d-flex flex-align-center text-uppercase text-primary text-yanone ml-auto"
                >
                    <span style="margin-bottom: -2px">Ver mais</span>
                    <i class="icon-cr icon-chevron-right" />
                </router-link>
            </div>
            <ProductGroupList
                :limit="4"
                :products="region.products.data"
                class="product-horizontal-list product-horizontal-list-4"
            />
        </div>

        <div v-if="partnersWithLogo.length">
            <div class="d-flex flex-align-center mt-5 mb-3">
                <h3 class="my-0 flex-child-fixed">Coleções</h3>
                <router-link
                    :to="{ name: `${regionName}-collections` }"
                    class="flex-child-fixed d-flex flex-align-center text-uppercase text-primary text-yanone ml-auto"
                >
                    <span style="margin-bottom: -2px">Ver produtos</span>
                    <i class="icon-cr icon-chevron-right" />
                </router-link>
            </div>
            <div class="product-horizontal-list product-horizontal-list-4 flex-align-center">
                <div v-for="partner in partnersWithLogo" class="mb">
                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/site/parceiros/logos/${partner.logo_image}?fit=max&h=200&w=350`"
                        class="lazy lazy-fade img-responsive block mx-auto"
                        style="max-height: 100px; max-width: 175px"
                    />
                </div>
            </div>
        </div>

        <div v-if="podcasts && podcasts.length">
            <div class="d-flex flex-align-center mt-5 mb-3">
                <h3 class="my-0 flex-child-fixed">Podcasts</h3>
                <router-link
                    :to="{ name: `${regionName}-podcasts` }"
                    class="flex-child-fixed d-flex flex-align-center text-uppercase text-primary text-yanone ml-auto"
                >
                    <span style="margin-bottom: -2px">Ver mais</span>
                    <i class="icon-cr icon-chevron-right" />
                </router-link>
            </div>
            <CountryRegionPodcast :item="podcasts[0]" />
        </div>

        <div v-if="posts && posts.length">
            <div class="d-flex flex-align-center mt-5 mb-3">
                <h3 class="my-0">Nosso Blog</h3>
                <router-link
                    :to="{ name: `${regionName}-blog` }"
                    class="flex-child-fixed d-flex flex-align-center text-uppercase text-primary text-yanone ml-auto"
                >
                    <span style="margin-bottom: -2px">Ver mais</span>
                    <i class="icon-cr icon-chevron-right" />
                </router-link>
            </div>
            <CountryRegionBlogPost :item="posts[0]" />
        </div>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../common/common';
    import ProductGroupList from '../product/ProductGroupList';
    import CountryRegionBlogPost from './CountryRegionBlogPost';
    import CountryRegionPodcast from './CountryRegionPodcast';

    export default {
        name: 'CountryRegionHome',

        components: {
            ProductGroupList,
            CountryRegionPodcast,
            CountryRegionBlogPost,
        },

        props: {
            region: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            updateLazyLoad();
        },

        computed: {
            regionName() {
                return this.region.name.toLowerCase();
            },

            posts() {
                return this.region.resources.data.filter(
                    (r) => r.url.indexOf('https://blog') === 0
                );
            },

            podcasts() {
                return this.region.resources.data.filter(
                    (r) => r.url.indexOf('https://open.spotify') === 0
                );
            },

            partnersWithLogo() {
                return this.region.partners.data.filter((p) => p.logo_image);
            },
        },
    };
</script>